var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comments"},[(_vm.comments)?_c('div',_vm._l((_vm.comments),function(comment){return _c('CommentItem',{key:'comment' + comment.id,attrs:{"comment":comment},on:{"submit":_vm.fetchComments}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }